import { mainApiUrl, baseHeaders, storeId } from '@constants'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getStateFromLocalStorage, storeStateAtLocalStorage } from '@src/reduxjs'
import ms from 'ms'

const initialState = {
  modal: {
    isOpen: false,
    data: {},
  },
  sendConfirm: {
    isOpen: false,
    data: {},
    method: '',
  },
  deleteConfirm: {
    isOpen: false,
    data: {},
  },
  invoiceConfirm: {
    isOpen: false,
    data: {},
  },
}

export const getOrderThunk = createAsyncThunk('orders/getOrderThunk', async (order, { getState, rejectWithValue }) => {
  const headers = { ...baseHeaders, Authorization: `JWT ${getState().auth.jwtToken}` }

  const response = await fetch(`${mainApiUrl}/orders/${order.id}`, { signal: AbortSignal.timeout(ms('10s')), headers, method: 'GET' })
  const json = await response.json()

  if (response.status !== 200) {
    return rejectWithValue({ ...json, status: response.status })
  }

  return json
})

export const markStoreZipDownloadThunk = createAsyncThunk('orders/markStoreZipDownloadThunk', async ({ id }, { getState, rejectWithValue }) => {
  const headers = { ...baseHeaders, Authorization: `JWT ${getState().auth.jwtToken}` }

  const response = await fetch(`${mainApiUrl}/orders/${id}/store_zip_download`, { signal: AbortSignal.timeout(ms('5s')), headers, method: 'PUT' })

  if (response.status !== 200) {
    return rejectWithValue(response)
  }

  return await response.json()
})

export const getExportThunk = createAsyncThunk('orders/getExportThunk', async ({ from, to, currency, filename = 'export.xlsx' }, { getState, rejectWithValue }) => {
  const headers = { ...baseHeaders, Authorization: `JWT ${getState().auth.jwtToken}` }

  const response = await fetch(`${mainApiUrl}/stores/${storeId}/orders/export?from=${from}&to=${to}&currency=${currency}`, { headers, method: 'GET' })

  if (response.status !== 200) {
    return rejectWithValue(response)
  }

  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()

  return url
})

const ordersSlice = createSlice({
  name: 'orders',
  initialState: { ...initialState, ...getStateFromLocalStorage('orderslice') },
  reducers: {
    setModalData: (state, action) => {
      state.modal.data = action.payload || initialState.modal.data
    },
    setModalIsOpen: (state, action) => {
      state.modal.isOpen = action.payload || initialState.modal.isOpen
    },
    setSendConfirmIsOpen: (state, action) => {
      state.sendConfirm.isOpen = action.payload || initialState.sendConfirm.isOpen
    },
    setSendConfirmData: (state, action) => {
      state.sendConfirm.data = action.payload || initialState.sendConfirm.data
    },
    setSendConfirmMethod: (state, action) => {
      state.sendConfirm.method = action.payload || initialState.sendConfirm.method
    },
    setConfirmDeleteIsOpen: (state, action) => {
      state.deleteConfirm.isOpen = action.payload || initialState.deleteConfirm.isOpen
    },
    setConfirmDeleteData: (state, action) => {
      state.deleteConfirm.data = action.payload || initialState.deleteConfirm.data
    },
    setConfirmInvoiceIsOpen: (state, action) => {
      state.invoiceConfirm.isOpen = action.payload || initialState.invoiceConfirm.isOpen
    },
    setConfirmInvoiceData: (state, action) => {
      state.invoiceConfirm.data = action.payload || initialState.invoiceConfirm.data
    },
  },
})

export const {
  setModalData,
  setModalIsOpen,
  setSendConfirmIsOpen,
  setSendConfirmData,
  setSendConfirmMethod,
  setConfirmDeleteIsOpen,
  setConfirmDeleteData,
  setConfirmInvoiceIsOpen,
  setConfirmInvoiceData,
} = ordersSlice.actions

export default ordersSlice
